import { render, staticRenderFns } from "./OrderDetailPaymentTypeRow.vue?vue&type=template&id=2a9b5660&"
import script from "./OrderDetailPaymentTypeRow.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPaymentTypeRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPaymentTypeRow.vue?vue&type=style&index=0&id=2a9b5660&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports